import { Container } from 'react-bootstrap';
import styled from 'styled-components';

export const Block = styled(Container)`
  background-color: ${props => props.theme.colors.surface};
  box-shadow: ${props => props.theme.shadows.sm};
  border: 1px solid ${props => props.theme.colors.border};
  padding: ${props => props.theme.spacing.lg};
  border-radius: ${props => props.theme.radii.md};

  p,
  label {
    font-style: normal;
    font-weight: ${props => props.theme.typography.weights.regular};
    font-size: ${props => props.theme.typography.sizes.sm};
    line-height: ${props => props.theme.typography.lineHeights.sm};
    color: ${props => props.theme.colors.textSecondary};
  }

  select,
  input {
    border: 1px solid ${props => props.theme.colors.border} !important;
    box-sizing: border-box !important;
  }

  select::placeholder {
    font-style: normal;
    font-weight: normal;
    font-size: ${props => props.theme.typography.sizes.sm};
    line-height: ${props => props.theme.typography.lineHeights.sm};
    color: ${props => props.theme.colors.textMuted} !important;
  }
`;

export const BlcokSB = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: ${props => props.theme.spacing.lg};
  /* overflow: hidden; */

  > div {
    width: 48%;
  }

  > div:nth-child(2) {
    display: flex;
    justify-content: space-between;
  }
`;

export const InputArea = styled.input`
  background: ${props => props.theme.colors.surface};
  border: 1px solid ${props => props.theme.colors.border};
  box-sizing: border-box;
  border-radius: ${props => props.theme.radii.md};
  padding: ${props => props.theme.spacing.sm} ${props => props.theme.spacing.md};
  width: 100%;
  min-height: 112px;
  resize: vertical;
  outline: none;
  color: ${props => props.theme.colors.textPrimary};
  font-size: ${props => props.theme.typography.sizes.sm};
  line-height: ${props => props.theme.typography.lineHeights.sm};
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: ${props => props.theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(46, 144, 250, 0.2);
  }
`;

export const InputText = styled.input`
  background: ${props =>
    props.disabled ? props.theme.colors.grayLight : props.theme.colors.surface};
  border: 1px solid ${props => props.theme.colors.border};
  box-sizing: border-box;
  border-radius: ${props => props.theme.radii.md};
  padding: ${props => props.theme.spacing.sm} ${props => props.theme.spacing.md};
  resize: none;
  outline: none;
  display: block;
  width: 100%;
  height: 36px;
  color: ${props => props.theme.colors.textPrimary};
  font-size: ${props => props.theme.typography.sizes.sm};
  line-height: ${props => props.theme.typography.lineHeights.sm};
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: ${props => props.theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(46, 144, 250, 0.2);
  }
`;

export const InputSelect = styled.select`
  background: ${props => props.theme.colors.surface};
  border: 1px solid ${props => props.theme.colors.border};
  box-sizing: border-box;
  border-radius: ${props => props.theme.radii.md};
  padding: ${props => props.theme.spacing.sm} ${props => props.theme.spacing.md};
  resize: none;
  outline: none;
  display: block;
  width: 100%;
  height: 36px;
  color: ${props => props.theme.colors.textPrimary};
  font-size: ${props => props.theme.typography.sizes.sm};
  line-height: ${props => props.theme.typography.lineHeights.sm};
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: ${props => props.theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(46, 144, 250, 0.2);
  }
`;

export const ButtonAdd = styled.button`
  background-color: ${props => props.theme.colors.secondary};
  color: ${props => props.theme.colors.white};
  padding: ${props => props.theme.spacing.sm} ${props => props.theme.spacing.xl};
  border: none;
  border-radius: ${props => props.theme.radii.md};
  max-width: 200px;
  font-weight: ${props => props.theme.typography.weights.semibold};
`;

export const AddVtmContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

export const AddVtm = styled.button`
  padding: ${props => props.theme.spacing.sm} ${props => props.theme.spacing.xl};
  border-radius: ${props => props.theme.radii.md};
  color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.success};
  border: none;
  font-weight: ${props => props.theme.typography.weights.semibold};
`;

export const InputTextLatLng = styled.input`
  background: ${props =>
    props.disabled ? props.theme.colors.grayLight : props.theme.colors.surface};
  border: 1px solid ${props => props.theme.colors.border};
  box-sizing: border-box;
  border-radius: ${props => props.theme.radii.md};
  padding: ${props => props.theme.spacing.sm} ${props => props.theme.spacing.md};
  resize: none;
  outline: none;
  display: block;
  width: 100%;
  height: 36px;
  margin-top: ${props => props.theme.spacing.xs};
  color: ${props => props.theme.colors.textPrimary};
  font-size: ${props => props.theme.typography.sizes.sm};
  line-height: ${props => props.theme.typography.lineHeights.sm};
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: ${props => props.theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(46, 144, 250, 0.2);
  }
`;

export const FormHeader = styled.h3`
  margin-top: ${props => props.theme.spacing.xl};
  margin-bottom: ${props => props.theme.spacing.xl};
  font-style: normal;
  font-weight: ${props => props.theme.typography.weights.semibold};
  font-size: ${props => props.theme.typography.sizes.lg};
  line-height: ${props => props.theme.typography.lineHeights.lg};
  text-align: center;
  color: ${props => props.theme.colors.textPrimary};
`;

export const DraftActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${props => props.theme.spacing.sm};
  margin-top: ${props => props.theme.spacing.sm};

  button {
    border-radius: ${props => props.theme.radii.md};
    border: 1px solid ${props => props.theme.colors.border};
    background-color: ${props => props.theme.colors.surface};
    color: ${props => props.theme.colors.textPrimary};
    padding: ${props => props.theme.spacing.sm}
      ${props => props.theme.spacing.lg};
    font-size: ${props => props.theme.typography.sizes.sm};
    font-weight: ${props => props.theme.typography.weights.semibold};
    line-height: ${props => props.theme.typography.lineHeights.sm};
    transition: background-color 0.2s ease, border-color 0.2s ease;
  }

  button:hover {
    background-color: ${props => props.theme.colors.grayLight};
    border-color: ${props => props.theme.colors.textMuted};
  }
`;
